import { render, staticRenderFns } from "./ClassGroupCompetitionAdmin.vue?vue&type=template&id=5d476b0c&scoped=true"
import script from "./ClassGroupCompetitionAdmin.vue?vue&type=script&lang=js"
export * from "./ClassGroupCompetitionAdmin.vue?vue&type=script&lang=js"
import style0 from "./ClassGroupCompetitionAdmin.vue?vue&type=style&index=0&id=5d476b0c&prod&scoped=true&lang=css"
import style1 from "./ClassGroupCompetitionAdmin.vue?vue&type=style&index=1&id=5d476b0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d476b0c",
  null
  
)

export default component.exports